import { TableCellData_VerticalAlignment } from './plugin_table_cell.enums.js';
/* eslint-disable */
export interface TableCellData {
  /** Styling for the cell's background color and text alignment. */
  cellStyle?: TableCellData_CellStyle;
  /** The cell's border colors. */
  borderColors?: TableCellData_BorderColors;
}

export function tableCellData_VerticalAlignmentFromJSON(
  object: any
): TableCellData_VerticalAlignment {
  switch (object) {
    case 0:
    case 'TOP':
      return TableCellData_VerticalAlignment.TOP;
    case 1:
    case 'MIDDLE':
      return TableCellData_VerticalAlignment.MIDDLE;
    case 2:
    case 'BOTTOM':
      return TableCellData_VerticalAlignment.BOTTOM;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TableCellData_VerticalAlignment.UNRECOGNIZED;
  }
}

export function tableCellData_VerticalAlignmentToJSON(
  object: TableCellData_VerticalAlignment
): string {
  switch (object) {
    case TableCellData_VerticalAlignment.TOP:
      return 'TOP';
    case TableCellData_VerticalAlignment.MIDDLE:
      return 'MIDDLE';
    case TableCellData_VerticalAlignment.BOTTOM:
      return 'BOTTOM';
    default:
      return 'UNKNOWN';
  }
}

export interface TableCellData_CellStyle {
  /** Vertical alignment for the cell's text. */
  verticalAlignment: TableCellData_VerticalAlignment;
  /** Cell background color as a hexadecimal value. */
  backgroundColor?: string;
}

export interface TableCellData_BorderColors {
  /** Left border color as a hexadecimal value. */
  left?: string;
  /** Right border color as a hexadecimal value. */
  right?: string;
  /** Top border color as a hexadecimal value. */
  top?: string;
  /** Bottom border color as a hexadecimal value. */
  bottom?: string;
}

const baseTableCellData: object = {};

export const TableCellData = {
  fromJSON(object: any): TableCellData {
    const message = { ...baseTableCellData } as TableCellData;
    message.cellStyle =
      object.cellStyle !== undefined && object.cellStyle !== null
        ? TableCellData_CellStyle.fromJSON(object.cellStyle)
        : undefined;
    message.borderColors =
      object.borderColors !== undefined && object.borderColors !== null
        ? TableCellData_BorderColors.fromJSON(object.borderColors)
        : undefined;
    return message;
  },

  toJSON(message: TableCellData): unknown {
    const obj: any = {};
    message.cellStyle !== undefined &&
      (obj.cellStyle = message.cellStyle
        ? TableCellData_CellStyle.toJSON(message.cellStyle)
        : undefined);
    message.borderColors !== undefined &&
      (obj.borderColors = message.borderColors
        ? TableCellData_BorderColors.toJSON(message.borderColors)
        : undefined);
    return obj;
  },
};

const baseTableCellData_CellStyle: object = {
  verticalAlignment: TableCellData_VerticalAlignment.TOP,
};

export const TableCellData_CellStyle = {
  fromJSON(object: any): TableCellData_CellStyle {
    const message = { ...baseTableCellData_CellStyle } as TableCellData_CellStyle;
    message.verticalAlignment =
      object.verticalAlignment !== undefined && object.verticalAlignment !== null
        ? tableCellData_VerticalAlignmentFromJSON(object.verticalAlignment)
        : TableCellData_VerticalAlignment.TOP;
    message.backgroundColor =
      object.backgroundColor !== undefined && object.backgroundColor !== null
        ? String(object.backgroundColor)
        : undefined;
    return message;
  },

  toJSON(message: TableCellData_CellStyle): unknown {
    const obj: any = {};
    message.verticalAlignment !== undefined &&
      (obj.verticalAlignment = tableCellData_VerticalAlignmentToJSON(message.verticalAlignment));
    message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
    return obj;
  },
};

const baseTableCellData_BorderColors: object = {};

export const TableCellData_BorderColors = {
  fromJSON(object: any): TableCellData_BorderColors {
    const message = { ...baseTableCellData_BorderColors } as TableCellData_BorderColors;
    message.left =
      object.left !== undefined && object.left !== null ? String(object.left) : undefined;
    message.right =
      object.right !== undefined && object.right !== null ? String(object.right) : undefined;
    message.top = object.top !== undefined && object.top !== null ? String(object.top) : undefined;
    message.bottom =
      object.bottom !== undefined && object.bottom !== null ? String(object.bottom) : undefined;
    return message;
  },

  toJSON(message: TableCellData_BorderColors): unknown {
    const obj: any = {};
    message.left !== undefined && (obj.left = message.left);
    message.right !== undefined && (obj.right = message.right);
    message.top !== undefined && (obj.top = message.top);
    message.bottom !== undefined && (obj.bottom = message.bottom);
    return obj;
  },
};
